import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div style="text-align: justify;">
			
			<p class="mb-3">
				Все знают эти длинные гибкие ленты времени, которые продаются в магазинах. 
				Их можно купить по длине и делать из них всё, что можно и нужно, от еды до космических кораблей; зависит всё только от длины, ширины и толщины. 
				Ведь время можно мять, растягивать и сжимать – это знают все, на этом построена наша цивилизация. 
				Из изменений времени мы получаем энергию, как другие получают её из изменений материи или пространства. 
			</p>
			
			<p class="mb-3">
				Но вот что случилось однажды с одним маленьким мальчиком. 
			</p>
			
			<p class="mb-3">
				В нашей семье было несколько детей; старший уже заканчивал школу, двое учились в средних классах, а самый маленький, Ѭ, ещё оставался дома. 
				Все трое его родителей были люди занятые, и малыш часто был предоставлен самому себе. 
				Но он обычно не скучал, т.к. сам находил себе дело. 
				Особенно интересно было ему заглядывать в тетради и учебники старших братьев и сестёр. 
				И вот однажды он нашёл учебную шкалу времени для 6-го класса, где была представлена история какой-то вымышленной планеты. 
				Нужно было просто калибровать эту шкалу – навык, обычный для учеников 10-грегного возраста. 
				Но Ѭ достиг только 4-ёх грегов, и о калибровке ещё ничего не знал. 
				Он просто оторвал от подложки приятную на ощупь гладкую, мягкую и эластичную ленту времени и стал с ней играть: мять её, растягивать, сворачивать из неё разные фигурки. 
			</p>
			
			<p class="mb-3">
				Варфоломеевская ночь совпала у него с Ночью длинных ножей; расстрел русского царя Николая II c расстрелом мексиканского императора Максимилиана I 
				(почему в истории обычно пишут только о войнах и убийствах? 
				Но не страшно: ведь это была вымышленная планета с вымышленной историей – всего лишь учебный пример!). 
				Историю некоторых северных и южных племён ребёнок растянул на тысячелетия, в течение которых ничего не происходило и не изменялось. 
				А в некоторых латиноамериканских государствах он наоборот, закрутил историю таким множеством узелков, что там каждые несколько лет повторялись перевороты, 
				которые снова и снова возвращали страну на прежний уровень. 
				Ну и начудил малый! 
				Испортил сестре оценку в школе…
			</p>
			
			<p class="mb-3">
				Мы купили ей новую тетрадь для практических работ, а его наказали лишением борскума на 1/20 грега. 
				Нужно с детства прививать уважительное отношение ко времени, в котором мы живём, которым питаемся и из которого построено всё в нашем мире! 
			</p>
			
			<p class="mb-3">
				Но испорченную тетрадку пришлось всё же выбросить. 
				Ничего! У нас много времени! 
				И ведь это была всего лишь учебная задачка о вымышленной планете! 
				Её придумали для задания, – и просто выбросили из времени, когда её испортил ребёнок. 
			</p>
			
			<p class="mb-3">
				А Ѭ вырос хорошим мальчиком и больше не баловался со временем.
			</p>
			
			
		</div>
		`
	)
}

const itemName = {
	rus: `Детские шалости`
}

const itemDate = {
	rus: `29 сентября 2021 г.`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;